// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-functionalities__container {
    margin-top: 46px;
    width: 100%;
}
.baloa-pro-functionalities__row {
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 10px 0;
}

.baloa-pro-functionalities__row-text-title {
    color: var(--black-color);
    font-size: 20px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-medium);
    letter-spacing: -0.3px;
    width: 80%;
    padding: 10px;
}

.baloa-pro-functionalities__row-text-title2 {
    color: var(--black-color);
    font-size: 19px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-regular);
    letter-spacing: -0.3px;
    width: 10%;
    padding: 10px 24px;
    text-align: center;
}

.baloa-pro-functionalities__row-text-icon {
    color: var(--black-color);
    font-size: 19px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-bold);
    letter-spacing: -0.3px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10%;
    padding: 10px 24px;
}

.baloa-pro-functionalities__row-text-icon .hubicon-award_star {
    font-size: 22px;
    margin-left: 4px;
}

.baloa-pro-functionalities__row-text {
    color: var(--primary-very-dark-color);
    font-size: 16px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-regular);
    letter-spacing: -0.3px;
    width: 80%;
    padding: 10px;
}

.baloa-pro-functionalities__row-icon {
    font-size: 24px;
    text-align: center;
    width: 10%;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-pro-functionalities__container {
        margin-top: 12px;
    }

    .baloa-pro-functionalities__row-text-title {
        font-size: 14px;
        width: 70%;
    }

    .baloa-pro-functionalities__row-text-title2 {
        font-size: 14px;
        width: 15%;
        padding: 10px 0;
    }
    
    .baloa-pro-functionalities__row-text-icon {
        font-size: 14px;
        width: 15%;
        padding: 10px 0;
    }

    .baloa-pro-functionalities__row-text-icon .hubicon-award_star {
        font-size: 20px;
    }

    .baloa-pro-functionalities__row-text {
        font-size: 13px;
        width: 70%;
        padding: 0;
    }

    .baloa-pro-functionalities__row-icon {
        font-size: 22px;
        width: 15%;
    }

    .baloa-pro-functionalities__container.extended {
        margin-bottom: 170px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-functionalities/BaloaProFunctionalitiesComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yDAAyD;IACzD,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;IACtB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;IACtB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,eAAe;QACf,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,UAAU;IACd;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".baloa-pro-functionalities__container {\n    margin-top: 46px;\n    width: 100%;\n}\n.baloa-pro-functionalities__row {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 10px 0;\n}\n\n.baloa-pro-functionalities__row-text-title {\n    color: var(--black-color);\n    font-size: 20px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-medium);\n    letter-spacing: -0.3px;\n    width: 80%;\n    padding: 10px;\n}\n\n.baloa-pro-functionalities__row-text-title2 {\n    color: var(--black-color);\n    font-size: 19px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-regular);\n    letter-spacing: -0.3px;\n    width: 10%;\n    padding: 10px 24px;\n    text-align: center;\n}\n\n.baloa-pro-functionalities__row-text-icon {\n    color: var(--black-color);\n    font-size: 19px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-bold);\n    letter-spacing: -0.3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 10%;\n    padding: 10px 24px;\n}\n\n.baloa-pro-functionalities__row-text-icon .hubicon-award_star {\n    font-size: 22px;\n    margin-left: 4px;\n}\n\n.baloa-pro-functionalities__row-text {\n    color: var(--primary-very-dark-color);\n    font-size: 16px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-regular);\n    letter-spacing: -0.3px;\n    width: 80%;\n    padding: 10px;\n}\n\n.baloa-pro-functionalities__row-icon {\n    font-size: 24px;\n    text-align: center;\n    width: 10%;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-pro-functionalities__container {\n        margin-top: 12px;\n    }\n\n    .baloa-pro-functionalities__row-text-title {\n        font-size: 14px;\n        width: 70%;\n    }\n\n    .baloa-pro-functionalities__row-text-title2 {\n        font-size: 14px;\n        width: 15%;\n        padding: 10px 0;\n    }\n    \n    .baloa-pro-functionalities__row-text-icon {\n        font-size: 14px;\n        width: 15%;\n        padding: 10px 0;\n    }\n\n    .baloa-pro-functionalities__row-text-icon .hubicon-award_star {\n        font-size: 20px;\n    }\n\n    .baloa-pro-functionalities__row-text {\n        font-size: 13px;\n        width: 70%;\n        padding: 0;\n    }\n\n    .baloa-pro-functionalities__row-icon {\n        font-size: 22px;\n        width: 15%;\n    }\n\n    .baloa-pro-functionalities__container.extended {\n        margin-bottom: 170px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
